import LegalPage from './LegalPage';

const INTRO = `Mon Éclora accorde une attention particulière à la protection de vos données personnelles.
La présente politique explique quelles données peuvent être collectées, pourquoi elles le sont et quels sont vos droits.`;

const SECTIONS = [
    {
        h: '1. Responsable du traitement',
        body: `Le responsable du traitement est :

Mélanie PEYRE
Entrepreneur individuel — Mon Éclora
SIRET : 802 555 987 00022

Adresse :
1 bis chemin Belloc, 33530 Bassens

Email :
contact@mon-eclora.fr`,
    },
    {
        h: '2. Données collectées',
        body: `Lorsque vous utilisez le site ou vous inscrivez à Reset Éclora, Mon Éclora peut notamment collecter :

- votre prénom ;
- votre adresse email ;
- vos choix concernant la réception de communications ;
- les informations techniques nécessaires au fonctionnement et à la sécurité du site ;
- les informations nécessaires à la gestion de vos demandes.

D'autres données pourront être collectées ultérieurement si de nouveaux services sont ajoutés au site. La présente politique sera alors mise à jour.`,
    },
    {
        h: "3. Pourquoi ces données sont-elles utilisées ?",
        body: `Vos données peuvent être utilisées pour :

- vous envoyer Reset Éclora lorsque vous le demandez ;
- assurer le fonctionnement du service demandé ;
- répondre à vos messages et demandes ;
- gérer votre inscription et vos préférences ;
- vous envoyer La Lettre Éclora et d'autres communications de Mon Éclora lorsque vous avez donné votre consentement ;
- assurer la sécurité et le bon fonctionnement du site ;
- respecter les obligations légales applicables.`,
    },
    {
        h: '4. Bases légales',
        body: `Selon le traitement concerné, Mon Éclora traite vos données sur une base légale appropriée au regard du RGPD.

L'envoi de Reset Éclora à votre demande repose sur la fourniture du service que vous avez demandé.

L'envoi de communications de prospection électronique aux particuliers repose sur votre consentement lorsque celui-ci est requis.

Vous pouvez retirer votre consentement à tout moment, sans remettre en cause la licéité des traitements effectués avant ce retrait.`,
    },
    {
        h: '5. Newsletter et communications',
        body: `L'inscription à Reset Éclora ne doit pas automatiquement obliger l'utilisateur à accepter des communications commerciales facultatives.

Lorsque cela est nécessaire, une case séparée et non précochée permet à l'utilisateur d'accepter de recevoir La Lettre Éclora et les communications de Mon Éclora.

Chaque email marketing doit comporter un moyen simple permettant de se désinscrire.`,
    },
    {
        h: '6. Destinataires et prestataires',
        body: `Les données sont destinées à Mon Éclora.

Elles peuvent également être traitées par les prestataires techniques strictement nécessaires au fonctionnement du service, notamment :

- l'hébergeur du site ;
- le prestataire d'emailing ;
- les éventuels prestataires techniques ou analytiques utilisés par Mon Éclora.

Prestataire emailing :
[À COMPLÉTER LORSQUE L'OUTIL SERA CHOISI]

Hébergeur :
[À COMPLÉTER]

Mon Éclora ne vend pas les données personnelles de ses utilisateurs.`,
    },
    {
        h: "7. Transferts hors Union européenne",
        body: `Certains prestataires techniques utilisés par Mon Éclora peuvent traiter des données en dehors de l'Espace économique européen.

Lorsque cela se produit, Mon Éclora veille à utiliser des prestataires mettant en place les garanties requises par la réglementation applicable.

Cette rubrique devra être précisée en fonction des prestataires effectivement utilisés par le site.`,
    },
    {
        h: '8. Durée de conservation',
        body: `Les données personnelles sont conservées uniquement pendant la durée nécessaire aux finalités pour lesquelles elles ont été collectées, ainsi que pendant les éventuelles durées imposées par la réglementation.

Les données utilisées à des fins de prospection ne sont pas conservées indéfiniment.

Les demandes de désinscription sont prises en compte afin de ne plus envoyer les communications concernées.`,
    },
    {
        h: '9. Vos droits',
        body: `Dans les conditions prévues par la réglementation applicable, vous pouvez notamment disposer :

- d'un droit d'accès à vos données ;
- d'un droit de rectification ;
- d'un droit à l'effacement ;
- d'un droit à la limitation du traitement ;
- d'un droit d'opposition dans les situations prévues par la loi ;
- d'un droit de retirer votre consentement à tout moment lorsque le traitement repose sur celui-ci ;
- le cas échéant, d'un droit à la portabilité.

Pour exercer vos droits :
contact@mon-eclora.fr

Une vérification de votre identité pourra être demandée lorsque cela est nécessaire pour sécuriser votre demande.

Vous disposez également du droit d'introduire une réclamation auprès de la CNIL.`,
    },
    {
        h: '10. Cookies',
        body: `Le site peut utiliser des cookies strictement nécessaires à son fonctionnement.

Si des cookies ou traceurs nécessitant le consentement sont ajoutés ultérieurement, notamment pour certaines fonctionnalités de mesure d'audience, publicité ou services tiers, un dispositif permettant d'accepter ou de refuser ces traceurs devra être mis en place avant leur dépôt lorsque la réglementation l'exige.

La présente politique sera mise à jour en fonction des outils effectivement utilisés.`,
    },
    {
        h: '11. Sécurité',
        body: `Mon Éclora met en œuvre des mesures raisonnables destinées à protéger les données personnelles contre la perte, l'accès non autorisé, la divulgation ou l'altération.`,
    },
    {
        h: '12. Modification de la politique',
        body: `Cette politique peut évoluer afin de tenir compte des modifications du site, des outils utilisés ou de la réglementation.

La date de dernière mise à jour est indiquée en haut de cette page.`,
    },
    {
        h: '13. Contact',
        body: `Pour toute question concernant vos données personnelles :
contact@mon-eclora.fr

Instagram : https://www.instagram.com/mon.eclora/`,
    },
];

export default function PolitiqueConfidentialite() {
    return (
        <LegalPage
            title="Politique de confidentialité"
            updated="septembre 2026"
            intro={INTRO}
            sections={SECTIONS}
            otherHref="/mentions-legales"
            otherLabel="Mentions légales"
        />
    );
}
